module.exports = __webpack_public_path__ + "static/media/aboutus-banner.c6f9f4a8.jpg";